
export const checkPermissions = (
  screen: string,
  action: string,
  permissions: Record<string, string>,
) => {
  if (!screen || !action) return false;
  if (
    permissions &&
    permissions[screen] &&
    permissions[screen]?.length > 0 &&
    permissions[screen].includes(action)
  )
    return true;
  return false;
};
